import { render, staticRenderFns } from "./DashboardList.vue?vue&type=template&id=7732f5f2"
import script from "./DashboardList.vue?vue&type=script&lang=js"
export * from "./DashboardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports